<template>
  <div class="filter-set site-ownership">
    <div class="filter-name">
      <span class="filter-name__label">Tontin omistus</span>
      <i class="toggle-expander icon-chevron-down"></i>
    </div>
    <expander :expanded="expanderVisible">
      <RadioButtonGroup
        v-model="selectedModeOfOwnershipModel"
        :options="[
          { value: String(modesOfOwnership.all.id), label: 'Näytä kaikki' },
          { value: String(modesOfOwnership.owned.id), label: 'Oma' },
          { value: String(modesOfOwnership.rented.id), label: 'Vuokra' },
        ]"
        name="ownership"
        ariaLabel="Tontin omistus"
      />
    </expander>
  </div>
</template>

<script lang="ts">
import Expander from '../expander/expander.vue';
import config from '@/config';
import searchUtils from '@/app/utils/search-utils';
import RadioButtonGroup from '@/app/components/form/radiobutton-group.vue';

export default {
  name: 'site-ownership',
  data: () => ({
    modesOfOwnership: config.SITE_OWNERSHIP,
  }),
  props: {
    expanderVisible: {
      type: Boolean,
      default: undefined,
    },
    selectedModeOfOwnership: {
      type: String,
      default: config.SITE_OWNERSHIP.all.id,
    },
  },
  computed: {
    selectedModeOfOwnershipModel: {
      get() {
        return this.selectedModeOfOwnership;
      },
      set(value: string) {
        const updates = { siteOwnership: value === this.modesOfOwnership.all.id ? undefined : value };
        searchUtils.addFilterToUrl(this.$router, this.$route, updates);
      },
    },
  },
  components: {
    Expander,
    RadioButtonGroup,
  },
};
</script>
